import { render, staticRenderFns } from "./communityShare.vue?vue&type=template&id=07d6ec25&scoped=true&"
import script from "./communityShare.vue?vue&type=script&lang=js&"
export * from "./communityShare.vue?vue&type=script&lang=js&"
import style0 from "./communityShare.vue?vue&type=style&index=0&id=07d6ec25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d6ec25",
  null
  
)

export default component.exports